import { styled } from "@mui/material";

export const Wrapper = styled('div')`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;

    @media screen and (max-width: 800px) {
        flex-wrap: wrap;
        justify-content: center;
    }
`;